/* eslint-disable */
/**
 * CÓPIA da folha de estilo do widget de NPS. **Isto é um contorno temporário.**
 *
 * Origem: https://nps-new.ambevdevs.com.br/f48e360cfaca42028fde.css
 * Widget:  2.0.1
 * Last-Modified do arquivo de origem: Wed, 10 Jun 2026 18:46:15 GMT
 *
 * Por que existe: a CSP servida pelo frontend-reverse-proxy do MAZ libera no
 * `style-src` o host de *staging* do NPS (`nps-new-stg`) e não o de produção
 * (`nps-new`), então o `<link>` que o widget monta é bloqueado e o modal pinta
 * sem estilo nenhum — vira conteúdo em fluxo no rodapé da página.
 *
 * Por que uma cópia e não um fetch: o `connect-src` deixa o fetch sair, mas o
 * CDN do NPS não devolve `Access-Control-Allow-Origin` nos assets estáticos
 * (devolve na API `/nps/surveys`, por isso a pesquisa carrega). Sem CORS não dá
 * para ler a folha em runtime. Como o `style-src` traz `'unsafe-inline'`, a
 * saída é embutir o conteúdo.
 *
 * COMO REMOVER: acrescente `https://nps-new.ambevdevs.com.br` ao `style-src` em
 * `nginx-config/csp-headers` do frontend-reverse-proxy. O `<link>` volta a
 * carregar sozinho, este arquivo deixa de ser usado e pode ser apagado junto
 * com o fallback em `use-load-nps.ts`.
 *
 * ATENÇÃO: esta cópia não acompanha atualizações do NPS. Enquanto ela estiver
 * em uso, uma mudança de visual do widget não chega ao México.
 */
const npsFallbackStylesheet = `
#ambevtech-nps {
    position: fixed;
    margin: 0;
    top: 0px;
    font-family: var(--font-family-base);
    font-size: var(--font-size-default);
    font-weight: var(--font-weight-semibold);
    background-color: transparent;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    display: flex;
    flex-direction: column;
    color: var(--color-neutral-500);
    height: 100%;
    width: 100%;
    padding: 0;
    z-index: 10040;
    pointer-events: none;
    --color-action-default: #00ab5d;
    --color-action-hover: #aae3c9;
    --color-brand-gradient: linear-gradient(90deg, #fd9d1e 0%, #e38202 100%);
    --color-contrast-brand: #0e0e0e;
    --color-contrast-white: #ffffff;
    --color-contrast-black: #0e0e0e;
    --color-contrast-focused: #490c97;
    --color-feedback-danger-100: #ffeaea;
    --color-feedback-danger-200: #f3c0be;
    --color-feedback-danger-300: #c92323;
    --color-feedback-danger-400: #ae1e1e;
    --color-feedback-danger-500: #8e1818;
    --color-feedback-danger-600: #7a130a;
    --color-feedback-positive-100: #e1fce9;
    --color-feedback-positive-200: #d0efbd;
    --color-feedback-positive-300: #00b261;
    --color-feedback-positive-400: #08663b;
    --color-feedback-positive-500: #053821;
    --color-feedback-positive-600: #273f32;
    --color-feedback-warning-100: #fff0de;
    --color-feedback-warning-200: #ffd0ad;
    --color-feedback-warning-300: #ff9040;
    --color-feedback-warning-400: #db5c00;
    --color-feedback-warning-500: #943e00;
    --color-feedback-warning-600: #853e00;
    --color-neutral-100: #ffffff;
    --color-neutral-200: #d9d9d9;
    --color-neutral-300: #bfbfbf;
    --color-neutral-400: #666666;
    --color-neutral-500: #292929;
    --color-neutral-600: #0e0e0e;
    --color-neutral-background: #f2f2f2;
    --color-opacity-default: rgba(61, 13, 13, 0.32);
    --color-opacity-hover: rgba(254,206,144, 0.32);
    --color-opacity-disabled: rgba(41, 41, 41, 0.5);
    --color-opacity-error: rgba(255,234,234, 0.32);
    --font-family-base: 'IBM Plex Sans', sans-serif;
    --font-weight-semibold: 600;
    --font-weight-medium: 500;
    --font-weight-regular: 400;
    --velocity-slow: 0.275s;
    --velocity-medium: 0.225s;
    --velocity-fast: 0.150s;
    --vibe-soft: Cubic-bezier(0.48, 0, 0.48, 1);
    --vibe-energetic: Cubic-bezier(0.64, 0, 0.92, 1);
    --vibe-calm: Cubic-bezier(0.08, 0, 0.35, 1);
    --border-radius-none: 0rem;
    --border-radius-sm: 0.125rem;
    --border-radius-default: 0.25rem;
    --border-radius-md: 0.5rem;
    --border-radius-lg: 1rem;
    --border-radius-pill: 31.25rem;
    --border-radius-circular: 50%;
    --border-width-none: 0rem;
    --border-width-xs: 0.063rem;
    --border-width-default: 0.1rem;
    --border-width-sm: 0.125rem;
    --border-width-lg: 0.25rem;
    --border-width-xl: 0.5rem;
    --font-size-xs: 0.75rem;
    --font-size-sm: 0.875rem;
    --font-size-default: 1rem;
    --font-size-lg: 1.25rem;
    --font-size-xl: 1.5rem;
    --font-size-2xl: 2rem;
    --font-size-3xl: 2.5rem;
    --font-size-4xl: 3rem;
    --font-size-5xl: 4rem;
    --font-size-6xl: 5rem;
    --font-size-7xl: 6rem;
    --line-height-default: 100%;
    --line-height-xs: 120%;
    --line-height-sm: 144%;
    --line-height-md: 152%;
    --line-height-lg: 184%;
    --line-height-xl: 200%;
    --opacity-level-1: 0.72;
    --opacity-level-2: 0.64;
    --opacity-level-3: 0.32;
    --opacity-level-4: 0.16;
    --opacity-level-5: 0.08;
    --shadow-level-1: 0rem 0.25rem 0.5rem;
    --shadow-level-2: 0rem 0.5rem 1.5rem;
    --shadow-level-3: 0rem 1rem 2rem;
    --shadow-level-4: 0rem 1rem 3rem;
    --spacing-inset-size-2xs: 0.25rem;
    --spacing-inset-size-xs: 0.5rem;
    --spacing-inset-size-sm: 1rem;
    --spacing-inset-size-lg: 1.5rem;
    --spacing-inset-size-xl: 2rem;
    --spacing-inset-size-2xl: 2.5rem;
    --spacing-size-5xs: 0.25rem;
    --spacing-size-4xs: 0.5rem;
    --spacing-size-3xs: 1rem;
    --spacing-size-2xs: 1.5rem;
    --spacing-size-xs: 2rem;
    --spacing-size-sm: 2.5rem;
    --spacing-size-md: 3rem;
    --spacing-size-lg: 3.5rem;
    --spacing-size-xl: 4rem;
    --spacing-size-2xl: 5rem;
    --spacing-size-3xl: 7.5rem;
    --spacing-size-4xl: 10rem;
    --spacing-size-5xl: 12.5rem;
  }

#ambevtech-nps button:not(:disabled), #ambevtech-nps [type=button]:not(:disabled), #ambevtech-nps [type=reset]:not(:disabled), #ambevtech-nps [type=submit]:not(:disabled) {
    cursor: pointer;
}

#ambevtech-nps .btn-back {
    width: 20px;
    height: 20px;
    margin-top: -20px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background-color: transparent;
    border: none;
}

#ambevtech-nps .btn-back-svg {
    width: 100%;
    height: 100%;
}

#ambevtech-nps .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    color: var(--color-neutral-600);
    pointer-events: auto;
    background-color: var(--color-neutral-100);
    background-clip: padding-box;
    border: var(--border-width-none) solid var(--color-neutral-100);
    border-radius: var(--border-radius-md);
    outline: 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

#ambevtech-nps .btn {
    display: inline-block;
    color: var(--color-neutral-600);
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    border: var(--border-width-sm) solid var(--color-neutral-600);
    background-color: var(--color-neutral-100);
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    border-radius: var(--border-radius-default);
    font-size: var(--font-size-default);
    font-weight: var(--font-weight-semibold);
    min-height: 48px;
    width: max-content;
    margin-bottom: 24px;
    margin-left: 24px;
    margin-right: 24px;
    padding: 12px;
}

#ambevtech-nps .btn-secondary, #ambevtech-nps .btn-secondary.btn.disabled, #ambevtech-nps .btn-secondary:disabled, #ambevtech-nps .btn-secondary.active, #ambevtech-nps .btn-secondary:active, #ambevtech-nps .btn-secondary:focus, #ambevtech-nps .btn-secondary.focus {
    color: var(--color-neutral-600);
    background-color: transparent;
    border-color: var(--color-contrast-brand);
    padding-left: 24px;
    padding-right: 24px;
    width: auto;
}

.success-message {
    justify-content: center;
    font-size: var(--font-size-lg);
    text-align: center;
    line-height: 24px;
    display: -webkit-box !important;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
}
.fail-message {
    justify-content: center;
    font-size: var(--font-size-lg);
    text-align: center;
    line-height: 24px;
}

.fail-detail-message {
    justify-content: center;
    font-size: var(--font-size-default);
    text-align: center;
    font-weight: var(--font-weight-regular);
}

.final-modal {
    display: flex;
    flex-direction: column; /* Define a disposição de bloco vertical */
    align-items: center; /* Centraliza os itens horizontalmente */
    justify-content: center; /* Centraliza os itens verticalmente */
    font-size: var(--font-size-xl);
    text-align: center;
    height: 202px;
}

#ambevtech-nps input, #ambevtech-nps button, #ambevtech-nps select, #ambevtech-nps optgroup {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}

#ambevtech-nps .fade {
    transition: opacity .15s linear;
    opacity: 1;
}

#ambevtech-nps .d-block {
    display: block!important;
}

#ambevtech-nps .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10045;
    width: 100vw;
    height: 100vh;
    background-color: var(--color-opacity-disabled);
    pointer-events: none;
}

#ambevtech-nps .form-label {
    font-weight: var(--font-weight-regular);
    padding-top: 24px;
    font-size: var(--font-size-default);
}
#ambevtech-nps .feedback-label {
    font-weight: var(--font-weight-regular);
}

#ambevtech-nps .row {
    display: flex;
    flex-wrap: wrap;
}

#ambevtech-nps .required:after {
    content: " *";
    color: var(--color-feedback-danger-300);
}

#ambevtech-nps label {
    display: inline-block;
}

#ambevtech-nps .score {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
    gap: 12px;
    padding: 40px 0;
}

#ambevtech-nps .btnbox {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-neutral-600);
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    border: var(--border-width-sm) solid var(--color-neutral-600);
    background-color: var(--color-neutral-100);
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    border-radius: var(--border-radius-default);
    font-size: var(--font-size-default);
    font-weight: var(--font-weight-semibold);
    height: 44px;
    width: 44px;
    margin-top: 8px;
    margin-bottom: 8px;
}

/* Neutral gray hover for all score buttons */
#ambevtech-nps .btnbox.red:hover,
#ambevtech-nps .btnbox.yellow:hover,
#ambevtech-nps .btnbox.green:hover {
    background-color: #e9ecef;
}

#ambevtech-nps .btn-clicked-red, .btnbox.red:active {
    background-color: #ff3636;
    color: #ffffff !important;
}

#ambevtech-nps .btn-clicked-yellow, .btnbox.yellow:active {
    background-color: #f76800;
    color: #ffffff !important;
}

#ambevtech-nps .btn-clicked-green, .btnbox.green:active{
    background-color: #00ab5d;
     border-color: #00ab5d;
    color: #ffffff !important;
}

/* Single button selection with primary color */
#ambevtech-nps .btn-selected-primary {
    background-color: var(--color-action-default) !important;
    border-color: var(--color-action-default) !important;
    color: var(--color-contrast-white) !important;
}

/* Dark mode styles */
#ambevtech-nps.dark-mode {
    --color-neutral-100: #1e1e1e;
    --color-neutral-200: #2d2d2d;
    --color-neutral-300: #3d3d3d;
    --color-neutral-400: #b0b0b0;
    --color-neutral-500: #e1e1e1;
    --color-neutral-600: #ffffff;
}

#ambevtech-nps.dark-mode .modal-content {
    background-color: #1e1e1e;
    color: #e1e1e1;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

#ambevtech-nps.dark-mode .modal-footer {
    background-color: #2d2d2d;
}

#ambevtech-nps.dark-mode .modal-backdrop {
    background-color: rgba(0, 0, 0, 0.7);
}

#ambevtech-nps.dark-mode .modal-question {
    color: #ffffff;
}

#ambevtech-nps.dark-mode .form-label,
#ambevtech-nps.dark-mode .feedback-label {
    color: #b0b0b0;
}

#ambevtech-nps.dark-mode .form-control {
    background-color: #2d2d2d;
    border-color: #3d3d3d;
    color: #e1e1e1;
}

#ambevtech-nps.dark-mode .form-control:focus {
    border-color: #00ab5d;
    background-color: #2d2d2d;
    outline: none;
}

#ambevtech-nps.dark-mode .btn {
    color: #e1e1e1;
    border-color: #3d3d3d;
    background-color: #2d2d2d;
}

#ambevtech-nps.dark-mode .btn:hover {
    background-color: #3d3d3d;
    border-color: #4d4d4d;
}

#ambevtech-nps.dark-mode .btn-secondary {
    color: #e1e1e1;
    background-color: #2d2d2d;
    border-color: #00ab5d;
}

#ambevtech-nps.dark-mode .btn-secondary:hover {
    background-color: #0d4d2e;
    border-color: #00ab5d;
}

#ambevtech-nps.dark-mode .btn-primary {
    background-color: #00ab5d;
    border-color: #00ab5d;
    color: #ffffff;
}

#ambevtech-nps.dark-mode .btn-primary:hover {
    background-color: #00c96b;
    border-color: #00c96b;
}

#ambevtech-nps.dark-mode .btnbox {
    background-color: #2d2d2d;
    border-color: #3d3d3d;
    color: #e1e1e1;
}

#ambevtech-nps.dark-mode .btnbox:hover {
    background-color: #3d3d3d;
    border-color: #4d4d4d;
}

#ambevtech-nps.dark-mode .btn-selected-primary {
    background-color: #00ab5d !important;
    border-color: #00ab5d !important;
    color: #ffffff !important;
}

/* Classification buttons selected state in dark mode */
#ambevtech-nps.dark-mode .btn-clicked-red,
#ambevtech-nps.dark-mode .btn-clicked-yellow,
#ambevtech-nps.dark-mode .btn-clicked-green {
    background-color: #00ab5d !important;
    border-color: #00ab5d !important;
    color: #ffffff !important;
}

#ambevtech-nps.dark-mode .success-message {
    color: #03dac6;
}

#ambevtech-nps.dark-mode .fail-message {
    color: #cf6679;
}

#ambevtech-nps.dark-mode .fail-detail-message {
    color: #b0b0b0;
}

/* Invert black PNG images to white in dark mode */
#ambevtech-nps.dark-mode .btn-close img,
#ambevtech-nps.dark-mode .ambevtech-img,
#ambevtech-nps.dark-mode .btn-back img {
    filter: invert(1) brightness(1.2);
}

#ambevtech-nps button, #ambevtech-nps select {
    text-transform: none;
}

#ambevtech-nps .btn:hover {
    color: var(--color-neutral-600);
    background-color: #13b86d;
}
/* button send when disabled */
#ambevtech-nps .btn-primary.btn.disabled, #ambevtech-nps .btn-primary:disabled {
    border: transparent;
    cursor: not-allowed;
    pointer-events: none;
    background-color: var(--color-neutral-300);
    color: var(--color-neutral-400);
}

#ambevtech-nps .btn-primary, #ambevtech-nps .btn-primary.active, #ambevtech-nps .btn-primary:active, #ambevtech-nps .btn-primary:focus, #ambevtech-nps .btn-primary.focus {
    color: var(--color-neutral-600);
    background-color: var(--color-action-default);
    border-color: var(--color-action-default);
}
/* input-text for comments */
#ambevtech-nps .form-control {
    font-family: inherit;
    display: block;
    width: 100%;
    height: calc(1.5em + 1.3rem + 2px);
    padding: 0.5rem 1rem;
    font-size: var(--font-size-default);
    font-weight: var(--font-weight-regular);
    line-height: var(--line-height-md);
    color: var(--color-neutral-500);
    background-color: var(--color-contrast-white);
    border: var(--border-width-default) solid var(--color-neutral-300);
    border-radius: var(--border-radius-default);
    box-shadow: none;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    margin-bottom: 40px;
    margin-top: 40px;
    resize: none;
}

#ambevtech-nps .form-control:focus {
    border-color: var(--color-contrast-brand); /* Cor da borda ao focar */
    outline: none;
}

#ambevtech-nps .modal {
    --nps-modal-width: 500px;
    --nps-modal-margin: 24px;
    --nps-modal-footer-gap: .5rem;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10050;
    display: none;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
    pointer-events: auto;
}

#ambevtech-nps .modal-header {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    margin-left: 24px;
    margin-right: 24px;
    margin-top: 24px;
    position: relative;
}
/* ambevtech logo */
#ambevtech-nps .ambevtech-img {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 150px;
    height: 25px;
    margin-top: -25px;
}

#ambevtech-nps .btn-close {
    box-sizing: content-box;
    color: var(--color-contrast-brand);
    background: transparent var(--nps-btn-close-icon) center/1em auto no-repeat;
    border: 0;
    margin-left: auto;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

#ambevtech-nps .modal-body {
    position: relative;
    flex: 1 1 auto;
    margin-left: 24px;
    margin-right: 24px;
}

#ambevtech-nps .modal.show .modal-dialog {
    transform: none;
}

#ambevtech-nps .modal.fade .modal-dialog {
    transition: transform .3s ease-out;
    transform: translateY(-50px);
}

#ambevtech-nps .modal-dialog-centered {
    display: flex;
    align-items: center;
    min-height: calc(100% - var(--nps-modal-margin) * 2);
}

#ambevtech-nps .modal-dialog {
    position: relative;
    width: auto;
    margin: var(--nps-modal-margin);
    pointer-events: auto;
}

#ambevtech-nps .modal-question {
    font-weight: var(--font-weight-semibold);
    font-size: var(--font-size-lg);
    color: var(--color-neutral-600);
    line-height: var(--line-height-md);
}

#ambevtech-nps .modal-footer {
    display: flex;
    flex-shrink: 0;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    padding: calc(var(--nps-modal-margin) - var(--nps-modal-footer-gap) * .5);
    border-top: 0 solid var(--color-neutral-100);
    border-bottom-right-radius: var(--border-radius-md);
    border-bottom-left-radius: var(--border-radius-md);
    background-color: var(--color-neutral-200);
}

#ambevtech-nps .modal-footer>* {
    margin: calc(var(--nps-modal-footer-gap) * .5);
}

#ambevtech-nps .me-2 {
    margin-right: 0.3rem!important;
}

#ambevtech-nps .me-3 {
    margin-right: 0;
}

#ambevtech-nps .hidden{
    display: none !important;
}

#ambevtech-nps .classification {
    margin-top: 48px;
    margin-bottom: 0;
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
}

#nps-version{
  visibility: hidden;
  position: absolute;
}

@media (min-width: 992px)  {
    #ambevtech-nps .modal-lg, #ambevtech-nps .modal-xl {
        --nps-modal-width: 800px;
    }
}

@media (min-width: 576px)  {
    #ambevtech-nps .modal {
        --nps-modal-margin: 1.75rem;
    }
    #ambevtech-nps .modal-dialog {
        max-width: var(--nps-modal-width);
        margin-right: auto;
        margin-left: auto;
    }
}
`;
export default npsFallbackStylesheet;
//# sourceMappingURL=nps-fallback-stylesheet.js.map